import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    Input,
    OnInit,
    ViewChild,
    TemplateRef,
    AfterViewInit,
} from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MobileService } from '@klickdata/core/mobile';
import { Filter, GlobalFilterProperty, TableFilterComponent } from '@klickdata/core/table';
import { Observable, shareReplay } from 'rxjs';
import { ResourceTableBaseComponent } from '../resource-table-base/resource-table-base.component';
import { AppScope } from '@klickdata/core/resource';
import { Customer } from '@klickdata/core/customer';

@Component({
    selector: 'app-material-welcome-select-bottom-sheet',
    templateUrl: './material-welcome-select-bottom-sheet.component.html',
    styleUrls: ['./material-welcome-select-bottom-sheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialWelcomeSelectBottomSheetComponent implements OnInit, AfterViewInit {
    GlobalFilterProperty = GlobalFilterProperty;
    public isMobile$: Observable<boolean>;
    @ViewChild('tableBase') tableBase: ResourceTableBaseComponent;
    AppScope = AppScope;
    pageSizeOptions = [25, 50, 100];
    @ViewChild('title', { static: true }) title: TemplateRef<any>;
    @ViewChild('img', { static: true }) img: TemplateRef<any>;
    @ViewChild('updated_at', { static: true }) updated_at: TemplateRef<any>;
    @ViewChild('tools', { static: true }) tools: TemplateRef<any>;
    @ViewChild(TableFilterComponent) filter: TableFilterComponent;
    columnsData: { [key: string]: TemplateRef<any> } = {};
    otherContext: { [key: string]: TemplateRef<any> } = {};
    columnsKeys = {
        img: { label: $localize`Image`, sortable: false },
        title: { label: $localize`Title`, sortable: true },
        updated_at: { label: $localize`Updated at`, sortable: true },
    };
    constructor(
        protected mobile: MobileService,
        public bottomSheetRef: MatBottomSheetRef<MaterialWelcomeSelectBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public customer: Customer
    ) {
        this.isMobile$ = this.mobile.isMobile().pipe(shareReplay());
    }

    ngOnInit(): void {}
    ngAfterViewInit(): void {
        this.columnsData['img'] = this.img;
        this.columnsData['title'] = this.title;
        this.columnsData['updated_at'] = this.updated_at;
        this.columnsData['tools'] = this.tools;
    }
}
